<template>
    <div class="body">
            <span>酒店地址:</span>
            <el-input class="hotelAddress" v-model="input" placeholder="请输入内容"></el-input>
            <br/>
            <span>周边设施:</span>
            <el-tag :key="tag" v-for="tag in dynamicTags" closable  :disable-transitions="false" @close="handleClose(tag)"> {{tag}}</el-tag>
            <br/>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
            <el-button  v-else class="button-new-tag hotelRim" size="small" @click="showInput">添加新标签</el-button>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        dynamicTags: ['如:距离XX商场XX米'],
        inputVisible: false,
        inputValue: '',
        input: ''
      };
    },
    methods: {
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      }
    }
  }
</script>

<style scoped>

.hotelAddress{
    width: 20%;
    /* margin-right: 72%; */
    margin-top: 1%;
}

.hotelRim{
    /* margin-right: 77%; */
    margin-top: 1%;
    margin-bottom: 1%;
}

.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/setup/hotelTraffic.vue